import { EProductType } from '../../../types/microfrontends/paymentWidget';

export const getProductType = (isSubscription: boolean): EProductType => {
  return isSubscription ? EProductType.Subscription : EProductType.Package;
};
